export const EMPTY_SHIM = '//empty.js';
